import { Icon } from "@iconify/react";
import { useContext } from "react";
import { createUseStyles } from "react-jss";
import { TranslationContext } from "../../contexts";
import { useQueryCart } from "../../hooks/cart";
import styleVariables, { projectColors } from "../../style_setup";

const styles = createUseStyles({
  CartIconComp: {
    position: "relative",
  },
  navbarItemIcon: {
    fontSize: "large",
    marginTop: "5px",
    "&:hover, &:focus": {
      transform: "scale(1.1)",
    },
  },
  cartCount: {
    position: "absolute",
    top: "-.4rem",
    right: "-.7rem",
    background: projectColors.orangePrimary,
    color: "white",
    borderRadius: "50%",
    width: "1.1rem",
    aspectRatio: "1/1",
    fontSize: "small",
    textAlign: "center",
  },
  textLabel: {},
  [`@media ${styleVariables.media.smallscreen}`]: {
    textLabel: {
      display: "none",
    },
  },
});
export const CartIconComp = () => {
  const classes = styles({});

  const { t } = useContext(TranslationContext);

  const { cart, error, isLoading } = useQueryCart();

  const cartItems = cart?.cartItems ?? [];
  const cartItemsSum = cartItems.reduce((acc, item) => acc + item.quantity, 0);
  return isLoading && !error ? null : (
    <article className={classes.CartIconComp}>
      <span className={classes.textLabel}>{t("cart")} </span>
      <Icon icon="fa6-solid:cart-shopping" className={classes.navbarItemIcon} />
      {cartItemsSum ? (
        <div className={classes.cartCount}>
          {cartItemsSum < 10 ? cartItemsSum : "9+"}
        </div>
      ) : null}
    </article>
  );
};
CartIconComp.propTypes = {};
